import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import logo from "./logo.png";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';


import ICO from './subComponents/admin/ICO'

import MainToken from './subComponents/admin/MainToken/MainToken'

import DateComponent from './subComponents/DateComponent'
import DatePriceProgress from './subComponents/DatePriceProgress'
import PaymentFormOrWhiteList from './subComponents/PaymentFormOrWhiteList'
import Price from "./subComponents/Price";
import WithdrawOrRefund from './subComponents/WithdrawOrRefund'
import AccountInfo from './subComponents/AccountInfo'
import DisplayedWeiData from './subComponents/DisplayedWeiData'
import { Web3StatusContext } from "./contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class Admin extends React.Component {
  static contextType = Web3StatusContext;

  render() {
    const { activeAccount } = this.context;

    // destructure drizzle and drizzleState from props
    if(activeAccount == null) {
      return (
        <div>Account not connected<br/>
          <button onClick={this.context.connect}>
            Connect Wallet
          </button>
        </div>
      );
    }

    return (
      <div className="App">
        <div>
          <img src={logo} alt="drizzle-logo" />
          <h1>GAMEFOREST Crowd Sale</h1>
          <p>
            Own your digital games!
          </p>
          <Accordion defaultActiveKey="0">
            <Card>
              <Accordion.Collapse eventKey="0">
                <AccountInfo
                drizzle={this.props.drizzle}
                drizzleState={this.props.drizzleState}
                accountIndex={0}
                units="ether"
                precision={3}
                />
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>

        <div>
          <p>
            <strong>You currently have : </strong>
            <DisplayedWeiData
              drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              contract="GAMEFOREST"
              method="balanceOf"
              methodArgs={[activeAccount]}
            />{" "}
            <ContractData
              drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              contract="GAMEFOREST"
              method="symbol"
              hideIndicator
            />
          </p>

          
          <Table striped bordered hover>
            <thead>
              <tr>
                <th colSpan="2">
                  <DatePriceProgress
                      drizzle={this.props.drizzle}
                      drizzleState={this.props.drizzleState}
                      firstDateName={1}
                      lastDateName={3}
                      firstRateName="initialRate"
                      lastRateName="finalRate"
                      currentRateName="getCurrentRate"
                      textOnly="true">

                  </DatePriceProgress>
                </th>
              </tr>
            </thead>
            <thead>
              <tr>
                <th>Opening Price</th>
                <th>Closing Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <ContractData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="initialRate"
                  />{" "}
                  <ContractData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFOREST"
                    method="symbol"
                    hideIndicator
                  />{"/BNB"}
                  <br/>
                  <Price
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    priceName="initialRate">
                  </Price>
                </td>
                <td>
                  <ContractData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="finalRate"
                  />{" "}
                  <ContractData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFOREST"
                    method="symbol"
                    hideIndicator
                  />{"/BNB"}
                  <br/>
                  <Price
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    priceName="finalRate">
                  </Price>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div>
        <h2>Main Token</h2>
        <h5>{this.props.drizzle.contracts.GAMEFOREST.address}</h5>
        <MainToken
        drizzle={this.props.drizzle}
        drizzleState={this.props.drizzleState}>

        </MainToken>
        <h2>ICO</h2>
        <h5>{this.props.drizzle.contracts.GAMEFORESTSale.address}</h5>
        <ICO
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}>
        </ICO>
        </div>

        <div className="section">
          <h2>GAMEFOREST Token</h2>
          <Table striped bordered hover>
            <thead>
              <tr>
                
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="right" width="50%">Total Supply</td>
                <td align="left">
                <DisplayedWeiData
                  drizzle={this.props.drizzle}
                  drizzleState={this.props.drizzleState}
                  method="totalSupply"
                  contract="GAMEFOREST"
                />{" "}
                <ContractData
                  drizzle={this.props.drizzle}
                  drizzleState={this.props.drizzleState}
                  contract="GAMEFOREST"
                  method="symbol"
                  hideIndicator/>
                </td>
              </tr>
              <tr>
                <td align="right">Softcap</td>
                <td align="left">
                  <DisplayedWeiData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="goal"
                  />{" BNB"}
                </td>
              </tr>
              <tr>
                <td align="right">Hardcap</td>
                <td align="left">
                  <DisplayedWeiData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="cap"
                  />{" "}
                  <ContractData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFOREST"
                    method="symbol"
                    hideIndicator
                  />
                </td>
              </tr>
              <tr>
                <td align="right">Opening Date</td>
                <td align="left">
                  <DateComponent drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    getterParameter={1}>
                  </DateComponent>
                </td>
              </tr>
              <tr>
                <td align="right">Closing Date</td>
                <td align="left">
                  <DateComponent drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    getterParameter={3}>
                  </DateComponent>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        
      </div>
    );
  };
}

export default Admin;
